jQuery(document).ready(function ($) {
    const blocks = $('.products-slider-block');

    blocks.each((key, block) => {
        const swiper_element = $(block).find('.swiper').get(0);
        const prev = $(block).find('.slider-navs__prev').get(0);
        const next = $(block).find('.slider-navs__next').get(0);
        const pagination = $(block).find('.slider-navs__pag').get(0);

        new Swiper(swiper_element, {
            spaceBetween: 10,
            loop: true,
            navigation: {
                nextEl: next,
                prevEl: prev
            },
            pagination: {
                el: pagination,
                type: 'bullets',
                clickable: true
            },
            breakpoints: {
                1: {
                    slidesPerView: 1,
                    spaceBetween: 20,
                    pagination: {
                        enabled: true
                    }
                },
                577: {
                    slidesPerView: 2,
                    spaceBetween: 30,
                    pagination: {
                        enabled: true
                    }
                },
                768: {
                    slidesPerView: 2,
                    spaceBetween: 30,
                    pagination: {
                        enabled: false
                    }
                },
                993: {
                    slidesPerView: 3,
                    spaceBetween: 30
                },
                1250: {
                    slidesPerView: 4,
                    spaceBetween: 30
                }
            }
        });
    });
});
